import {
  ButtonStyled,
  DangerButtonStyled,
  LightButtonStyled,
  PrimaryButtonStyled,
} from "./button.style";
import { ButtonProps, CircularProgress } from "@mui/material";
import { ButtonType } from "./types";

export const Button = (props: ButtonType & ButtonProps) => {
  const {
    type = "button",
    size = "small",
    variant = "contained",
    disableRipple = true,
    isLoading,
    startIcon,
    children,
    disabled,
    ...rest
  } = props;

  return (
    <ButtonStyled
      {...rest}
      type={type}
      variant={variant}
      size={size}
      disableRipple={disableRipple}
      startIcon={
        isLoading ? <CircularProgress size={18} color={"inherit"} /> : startIcon
      }
      disabled={disabled || isLoading}
      style={{ textTransform: "none" }}
    >
      {children && children}
    </ButtonStyled>
  );
};

export const PrimaryButton = (props: ButtonType & ButtonProps) => {
  const { children } = props;
  return (
    <PrimaryButtonStyled className="primary-button">
      <Button {...props}>{children}</Button>
    </PrimaryButtonStyled>
  );
};

export const LightButton = (props: ButtonType & ButtonProps) => {
  const { children } = props;
  return (
    <LightButtonStyled className="light-button">
      <Button {...props}>{children}</Button>
    </LightButtonStyled>
  );
};

export const DangerButton = (props: ButtonType & ButtonProps) => {
  const { children, variant } = props;
  const mappedVariant = variant === "outlined" ? "outline" : "filled";
  return (
    <DangerButtonStyled
      variant={mappedVariant}
      className="danger-outline-button"
    >
      <Button {...props}>{children}</Button>
    </DangerButtonStyled>
  );
};
